import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]

import { computed, onMounted, ref, watch } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useDateTime, can } from '@/composables';
import { PERMISSIONS } from '@/enum';
import useUserTreatmentPlansStore from '@/store/People/Person/TreatmentPlans';
import { NotesInterface } from '@/types';
import AddNote from './AddNote.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Notes',
  setup(__props) {

onMounted(() => getNotes());

const notes = ref<NotesInterface[]>([]);
const noteModalOpen = ref(false);
const treatmentPlansStore = useUserTreatmentPlansStore();
const toast = useToast();
const loadingNotes = ref(true);

watch(
  () => [treatmentPlansStore.userTreatmentPlans, treatmentPlansStore.treatmentPlanServices],
  () => getNotes(),
);

const getNotes: () => Promise<void> = async () => {
  if (can([PERMISSIONS.TREATMENT_PLANS_NOTES_INDEX])) {
    loadingNotes.value = true;
    const notesData = await treatmentPlansStore.getTreatmentPlanNotes();
    notes.value = !notesData ? [] : notesData;
    loadingNotes.value = false;
  }
};

const onAddNote = async (newNote: string) => {
  noteModalOpen.value = false;
  await treatmentPlansStore.addTreatmentPlanNote(newNote);
  toast.add({
    severity: 'success',
    summary: 'Added',
    detail: 'Note has been added',
    life: 3000,
  });
  getNotes();
};

const onCancelAdd = () => toggleNotesModal();

const toggleNotesModal = () => (noteModalOpen.value = !noteModalOpen.value);

const isLoadingNotes = computed(() => loadingNotes.value);

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "card-full-width" }, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Notes", -1)),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).TREATMENT_PLANS_NOTES_STORE]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              id: "add_notes_btn",
              type: "text",
              size: "small",
              text: "Add Note",
              "icon-left": "add",
              onClick: toggleNotesModal
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        class: _normalizeClass(["notes-table", { 'table-loading': isLoadingNotes.value }]),
        value: notes.value,
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: isLoadingNotes.value,
        "responsive-layout": "scroll",
        "scroll-height": "440px"
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("No Notes", -1)
        ]))]),
        default: _withCtx(() => [
          (notes.value.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, {
                  field: "created_at",
                  header: "Date"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.created_at))
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "created_at",
                  header: "Time"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_unref(useDateTime)().formatLocalDateTime(data.created_at))
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "created_by",
                  header: "Created by"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(data.created_by.display_name)
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "note",
                  header: "Note"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: "title",
                      textContent: _toDisplayString(data.title)
                    }, null, 8, _hoisted_5),
                    (data.note)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          textContent: _toDisplayString(data.note)
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "class"]),
      (noteModalOpen.value && _unref(can)([_unref(PERMISSIONS).TREATMENT_PLANS_NOTES_STORE]))
        ? (_openBlock(), _createBlock(AddNote, {
            key: 0,
            onSave: onAddNote,
            onCancel: onCancelAdd
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})